import { FlipperKey } from '~/store/flippers/types'
import { Dispatch } from '~/store/types'
import { ACCOUNT_STATEMENT_ACTIONS, FLIPPER_RESPONSE_MAP } from './const'
import { ActionTypes, StateFlippers } from './types'

export const setFlippers =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (keys: FlipperKey[], flipperResponse: any) => (dispatch: Dispatch<ActionTypes>) => {
    const flippers = new Map<keyof StateFlippers, boolean>()

    if (keys && flipperResponse) {
      keys.forEach((key) => {
        const prop = FLIPPER_RESPONSE_MAP[key]
        const enabled = flipperResponse[key] as boolean

        if (prop && enabled !== undefined) {
          flippers.set(prop, enabled)
        }
      })

      if (flippers.size > 0) {
        dispatch({
          type: ACCOUNT_STATEMENT_ACTIONS.SET_FLIPPERS,
          flippers,
        })
      }
    }
  }
